import type {
  DispatchAssignedRead,
  DispatchRead,
  DispatchUnassignedRead,
} from 'src/common/external/bambi-api/bambiApi';

// the header counts come from /dispatch/summary/, so nothing reads this
const EMPTY_SUMMARY: DispatchRead['summary'] = {
  completed: 0,
  will_call: 0,
  canceled: 0,
  on_time: 0,
  delayed: 0,
  assigned: 0,
};

export const combineDispatchHalves = (
  assigned: DispatchAssignedRead | undefined,
  unassigned: DispatchUnassignedRead | undefined
): DispatchRead | undefined =>
  assigned && unassigned
    ? { ...assigned, ...unassigned, summary: EMPTY_SUMMARY }
    : undefined;
